import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { SimpleModal } from '../modal/simple-modal'
import { CustomDatePicker } from '../datepicker'
import { Button } from '../buttons'

export const DateModal = ({
  dateModal,
  deliveryStartDate,
  deliveryEndDate,
  dueStartDate,
  dueEndDate,
  handleInput,
  setDateModal,
}) => {
  return (
    <SimpleModal
      isOpen={ dateModal.isOpen }
      title={ `Select ${dateModal.name === 'delivery' ? 'Delivery' : 'Due'} Date` }
      toggle={ () => setDateModal({ isOpen: false }) }
      description={
        <Row>
          <DropdownWrapper>
            <CustomDatePicker
              dateFormat='DD/MM/YYYY'
              selected={ dateModal.name === 'delivery'
                ? (deliveryStartDate ? moment(deliveryStartDate) : null)
                : (dueStartDate ? moment(dueStartDate) : null)
              }
              onChange={ e => handleInput(`${dateModal.name}StartDate`, e) }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <CustomDatePicker
              dateFormat='DD/MM/YYYY'
              selected={ dateModal.name === 'delivery'
                ? (deliveryEndDate ? moment(deliveryEndDate) : null)
                : (dueEndDate ? moment(dueEndDate) : null)
              }
              onChange={ e => handleInput(`${dateModal.name}EndDate`, e) }
            />
          </DropdownWrapper>
        </Row>
      }
      actions={
        <ButtonWrapper>
          <Button
            theme='#6c757d'
            width='82px'
            height='26px'
            onClick={ () => setDateModal({ isOpen: false }) }
          >
          Close
          </Button>
        </ButtonWrapper>
      }
    />
  )
}

const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const DropdownWrapper = styled.div`
  max-width: 150px;
  width: 100%;
  margin-right: 12px;
`

const ButtonWrapper = styled.div`
  margin-left: 12px;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/date-modal.js